module.exports = __webpack_public_path__ + "img/horizontal.d5a67f24.jpg";